<template>
    <v-app>
        <v-navigation-drawer v-model="openSidebar" app  :style="{ backgroundColor : $page.props.organization.themeOptions.primary}">
            <template v-slot:prepend>
                <div class="ma-4">
                    <logo class="ml-1" :logo="$page.props.organization.settings.main_logo_path"></logo>
                </div>
                <div class="mx-4">
                    <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="currentDate"
            label="Datum"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          color="primary"
          v-model="currentDate"
          no-title
          scrollable
          locale="sr-latn"
          @input="menu = false"
        >
        </v-date-picker>
      </v-menu>
                </div>
            </template>

            <v-list>
                <v-list-item-group v-model="currentIndex" mandatory>
                    <template v-for="(item, index) in appointments">
                        <v-list-item :key="item.id" @click="setAsCurrent(item, index)">
                            <template v-slot:default="{ active }" class="ceca">
                                <v-list-item-content>
                                    <v-list-item-title><b>{{item.course.title}}</b></v-list-item-title>
                                    <v-list-item-subtitle>{{item.trainer.full_name}}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    {{ item.start_at | formatTime }} -  {{ item.end_at | formatTime }}
                                </v-list-item-action>
                            </template>
                        </v-list-item>
                        <v-divider></v-divider>
                    </template>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar color="grey lighten-5" app elevation="0" >
            <v-app-bar-nav-icon @click="openSidebar = !openSidebar"></v-app-bar-nav-icon>
            <v-toolbar-title class="text-h4" v-if="current != null">{{current.course.title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon :title="$page.props.lang.exit_kiosk || 'Exit Quick appointment mode'" @click="exitKioskMode()">
                <v-icon>mdi-export</v-icon>
            </v-btn>
        </v-app-bar>

        <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>
        <v-main>
            <v-container>
                <div v-if="current != null">
                    <div style="margin-left:20px; margin-top:-15px; margin-bottom: 30px">
                        <span style="margin-right:20px;">{{current.start_at | fullDate}}</span>
                        <span style="margin-right:20px;">{{current.trainer.full_name}}</span>
                        <span>{{current.location.name}}</span>
                    </div>
                    <v-row style="margin-bottom:30px; margin-right:1px">
                        <v-col colas="12">
                        <v-autocomplete
                            append-icon=""
                            prepend-inner-icon="mdi-magnify"
                            hide-no-data
                            v-model="searchField"
                            @change="memberSelected"
                            multiple
                            hide-details
                            hide-selected
                            :items="resultMembers"
                            :search-input.sync="searchMembers"
                            item-text="full_name"
                            return-object
                            :placeholder="$page.props.lang.add_member || 'Add member'"
                            dense solo class="search-products">

                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn v-if="data.item.is_checkedin == false" @click.stop.prevent="checkIn(data.item)" small outlined color="primary">{{ $page.props.lang.check_in || "Check-in" }}</v-btn>
                                </v-list-item-action>
                            </template>
                        </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row v-if="current != null">
                        <v-col cols="12" md="3" sm="6" v-for="(member, index) in current.members" v-bind:key="index">
                            <v-card>
                                <v-card-text>
                                <v-row>
                                    <v-col cols="10">
                                        <v-img
                                        :src="member.profile_photo_url+'?w=50'"
                                        width="50"
                                        contain
                                        aspect-ratio="1"
                                        ></v-img>
                                        <div class="font-weight-regular text-h6 text-sm-subtitle-1">{{member.full_name}}</div>
                                    </v-col>
                                    <v-col cols="2">
                                         <v-icon v-if="member.status == 1" color="green"> mdi-check-circle-outline </v-icon>
                                    </v-col>
                                </v-row>
                               </v-card-text>

                                <v-card-actions>
                                    <v-btn icon v-if="member.notes_count > 0" @click="showNotesModal(member)">
                                        <v-icon>mdi-note</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" :loading="loading && loadingIndex == member.id" v-if="member.status != 1" @click="checkIn(member)">
                                        {{ $page.props.lang.check_in || "Check-in" }}
                                    </v-btn>
                                     <v-btn color="default" :loading="loading && loadingIndex == member.id" v-if="member.status == 1" @click="undoCheckIn(member)">
                                        {{ $page.props.lang.remove_member || 'Cancel' }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
            <v-dialog v-model="showNotes" max-width="768px">
                <v-card :loading="loadingNotes">
                    <v-toolbar elevation="0">
                        <v-toolbar-title>{{currentMember.full_name}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="showNotes = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="mt-4">
                    <v-timeline dense clipped>
                        <v-timeline-item v-for="note in notes" :key="note.id" class="mb-4" color="primary" small>
                            <v-row justify="space-between">
                                <v-col cols="7" v-html="note.description"></v-col>
                                <v-col class="text-right" cols="5">{{note.created_at | formatDate}}</v-col>
                            </v-row>
                        </v-timeline-item>
                    </v-timeline>
             </v-card-text>
                </v-card>
            </v-dialog>
        </v-main>
    </v-app>
</template>
<script>
import Logo from '@/js/Components/Logo'
import pickBy from 'lodash/pickBy'

export default {
    layout: null,
    components: {
        Logo
    },
    props: {
        appointments: Array,
        organization: Object,
        date: String
    },
    data() {
        return {
            currentDate: this.date,
            currentIndex:this.appointments.length > 0 ? 0 : null,
            openSidebar: true,
            messageObjects: [],
            current: this.appointments.length > 0 ? this.appointments[0] : null,
            searchMembers: null,
            resultMembers: [],
            searchField: [],
            loading: false,
            loadingIndex: -1,
            menu: false,
            showNotes: false,
            loadingNotes: false,
            currentMember: {},
            notes: []
        }
    },
    created(){


    },
    watch: {
        'this.$vuetify.breakpoint.width': (value) => {
            if(value < 600) {
                this.mobile = true
            }
        },
        currentDate(val){

            var request = {
                currentDate: this.currentDate
            }
            this.$inertia.visit("/backoffice/kiosk/classes", {
                data: pickBy(request),
                preserveState: true,
                onSuccess: page => {
                    this.current = this.appointments.length > 0 ? this.appointments[0] : null;
                }
            })
        },
        searchMembers(val) {

            if (val === '') {
                this.resultMembers = []
                return
            }

            if (this.isLoading) return

            this.isLoading = true;

            axios.get('/backoffice/kiosk/members/'+this.current.id, { params: { search: val }})
                .then(response => {
                    this.resultMembers = response.data.results
                    this.isLoading = false
                })
        },
    },
    methods: {
        setAsCurrent(item, index){
            this.current = item;
            this.currentIndex = index;
        },
        memberSelected(){
            this.searchField = [];
        },
        showNotesModal(member) {

            this.currentMember = member;
            this.loadingNotes = true;
             this.showNotes = true;

            axios.get('/backoffice/kiosk/notes/'+member.id)
                .then(r => {
                    this.loadingNotes = false;
                    this.notes = r.data.results;
                });

        },
        checkIn(member) {

            var request = {
                class_id: this.current.id,
                member_id: member.id
            }

            this.loading = true;
            this.loadingIndex = member.id;
            axios.post('/backoffice/kiosk/checkin', request)
                .then(response => {

                    if (response.data.status==="OK") {

                        let existing = this.current.members.find(x => x.id == response.data.member.id);

                        if(existing){
                            var index = this.current.members.indexOf(existing);
                            this.current.members[index].status = 1;
                        }else{
                            this.current.members.push(response.data.member);
                        }
                    } else {

                        this.messageObjects.push({
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        });
                    }

                    this.loading = false;
                    this.loadingIndex =-1;
                })
                .catch(error => {
                   this.loading = false;
                    this.loadingIndex =-1;
                })
        },
        undoCheckIn(member){

             var request = {
                class_id: this.current.id,
                member_id: member.id
            }

            this.loading = true;
            this.loadingIndex =member.id;
            axios.post('/backoffice/kiosk/undocheckin', request)
                .then(response => {
                    this.loading = false;
                    this.loadingIndex =-1;
                    if (response.data.status==="OK") {
                        member.status = null;
                    }else {

                    }
                })
                .catch(error => {
                   this.loading = false;
                    this.loadingIndex =-1;
                })
        },
        exitKioskMode(){
            window.location.href = "/backoffice";
        }
    }
}
</script>
